import React, { useCallback } from 'react';

import { AlineTransforms } from '@aline/common';
import type { LinkElement } from '@aline/common';
import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
import type { NodeEntry } from 'slate';
import { Path } from 'slate';
import { useEditor } from 'src/layout-engine';

import { EditLinkForm } from './EditLinkForm';
import { LinkIndicator } from './LinkIndicator';

export const editingLinkCMPath = makeVar<Path | null>(null);

export function useEditingLinkCMPath(): Path | null {
  return useReactiveVar(editingLinkCMPath);
}

export function useSetEditingLinkOpen(): {
  setEditingLinkOpen: (linkCMPath: Path) => void;
} {
  const editor = useEditor();

  const setEditingLinkOpen = useCallback(
    (linkCMPath: Path): void => {
      if (editor.selection) AlineTransforms.nudgeRangeToEdges(editor, { at: editor.selection });
      editingLinkCMPath(linkCMPath);
    },
    [editor]
  );

  return {
    setEditingLinkOpen,
  };
}

export interface LinkPopoverContentProps {
  linkEntry: NodeEntry<LinkElement>;
}

export function LinkPopoverContent({ linkEntry }: LinkPopoverContentProps): JSX.Element | null {
  const editingLinkPath = useEditingLinkCMPath();
  const isEditingLink = !!editingLinkPath && Path.equals(linkEntry[1], editingLinkPath);

  return isEditingLink ? (
    <EditLinkForm linkEntry={linkEntry} />
  ) : (
    <LinkIndicator linkEntry={linkEntry} />
  );
}
